<template>
    <div id="drug-order-items-relocation-container">
        <b-row>
            <b-col sm="12">
                <MdTitle v-bind:Text="$t('DrugOrderItemsRemoval.Title')" />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.DateReceivedFrom')"
                    :Model="parameters.dateReceivedFrom"
                    @input="InputReceivedFrom"
                    :Id="'DateReceivedFrom'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateRecFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.DateReceivedTo')"
                    :Model="parameters.dateReceivedTo"
                    @input="InputReceivedTo"
                    :Id="'DateReceivedTo'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateRecToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.ExpirationDateFrom')"
                    :Model="parameters.expirationDateFrom"
                    @input="InputExpirationFrom"
                    :Id="'ItemRemovalExpirationDateFrom'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isExpDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.ExpirationDateTo')"
                    :Model="parameters.expirationDateTo"
                    @input="InputExpirationTo"
                    :Id="'ItemRemovalExpirationDateTo'"
                    :Type="'date'"
                    :OnPressEnter="SearchItems"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isExpDateToValid"
                >
                </MdDateTime>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <!--<MdLookup
                    v-bind:ModelCode="parameters.drugCode"
                    v-bind:ModelDescription="DrugName"
                    v-bind:Label="$t('Medication.Drugs')"
                    v-bind:RefCode="'Drugs'"
                    v-bind:Api="'Drugs'"
                    v-bind:FieldCode="'drugCode'"
                    v-bind:FieldDescription="'drugname'"
                    :SearchTitle="$t('Medication.Drugs')"
                    :GetValues="onCodeConditionOk"
                    :SearchFieldCode="'Code'"
                    v-bind:Fields="BaseFields"
                />-->
                <MdLookupMultiSelect
                    v-bind:Label="$t('Medication.Drugs')"
                    v-bind:ModelCode="parameters.DrugCodeList"
                    v-bind:RefCode="'Drugs'"
                    v-bind:Api="'Drugs'"
                    v-bind:FieldCode="'drugCode'"
                    v-bind:FieldDescription="'drugname'"
                    :SearchTitle="$t('Medication.Drugs')"
                    :GetValues="getValuesDrugs"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'Code'"
                    :ServerSidePagination="true"
                    v-bind:Fields="BaseFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.LotNo')"
                    v-bind:Name="'Lot-number'"
                    v-bind:TypeProp="'text'"
                    v-on:change="ChangeLotNo"
                    v-bind:OnPressEnter="SearchItems"
                    v-model="parameters.lotNo"
                    v-bind:Id="'lot-number'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Location')"
                    v-bind:Options="pharmacyLocations"
                    v-bind:ModelArray="pharmacyVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    :Input="changeDropDownPharmacy"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('DrugOrderItemsRemoval.ShowLots')"
                    v-bind:Options="ShowLotsOptions"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Tag="'DrugOrderItemsShowLots'"
                    v-bind:RequireEvent="true"
                    v-bind:AllowEmpty="false"
                    v-bind:Multiple="false"
                    v-bind:Model="showAllLotModel"
                    :Input="ChangeShowAllModel"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="mt-3 text-right">
                    <button
                        v-on:click="SearchItems"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <MdTitle v-bind:Text="viewText" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" />
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="parameters.PageNumber"
                    v-bind:perPage="parameters.PageSize"
                    v-bind:pageOptions="pageOptions"
                    v-bind:IsItemRemoval="true"
                    :editIconEvent="editHandler"
                    v-bind:VisibleEditIcon="true"
                    :FieldsDate="fieldsDate"
                    v-bind:VisibleDeleteIcon="false"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                >
                </MdTable>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:Name="'btnReport'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="ShowReport()"
            />
        </div>

        <DrugOrderItemsRemovalEditDlg
            v-bind:visible="visibleEditDialog"
            v-model="editableItem"
            @close="closeHandler"
            @ok="okHandler"
            :reasonList="this.reasonList"
        >
        </DrugOrderItemsRemovalEditDlg>

        <ItemsRelocationRep
            :visible="isItemReloReportVisible"
            :closeWindow="closeItemReloReportWindow"
            @close="closeItemReloReportWindow"
            :winTitle="$t('DrugOrderItemsRemoval.Title')"
            :ReportName="'ItemRemoval'"
            :isRelocation="false"
        />

        <BaseModal
            v-if="SignotecVisible"
            ModalId="SignotecModalId"
            :TitleWindow="`Sign`"
            :width="'30%'"
            :height="'auto'"
            :HideModalFun="SignotecOnCancel"
            @Close="SignotecOnCancel"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.TitleOK'), variant: 'primary', action: SignotecOnOK }
            ]"
        >
            <MdSignotec
                ref="mdSignotec"
                @OnSignotecSubmitImage="SignotecOnSubmitImage"
                @OnSignotecError="SignotecOnError"
                @OnSignotecConfirm="SignotecOnConfirm"
                @OnSignotecCancel="SignotecOnCancel"
            />
        </BaseModal>
    </div>
</template>

<script>
import ePharmacyItemsLocationService from '@/services/epharmacylocation.service';
import ePharmacyItemsReceivedService from '@/services/epharmacyitemsreceived.service';
import EnumService from '@/services/enum.service';
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import Utils from '@/common/utils';
import ReasonService from '@/services/reason.service';
import DrugOrderItemsRemovalEditDlg from './DrugOrderItemsRemovalEditDlg';
import EmployeeService from '@/services/employee.service';
import LocalStorage from '@/services/storage.service';

export default {
    name: 'DrugOrderItemsRemoval',
    mixins: [DBFunctions, ShowMessage],
    components: {
        DrugOrderItemsRemovalEditDlg
    },

    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },
            DrugName: '',
            parameters: {
                dateReceivedFrom: null,
                dateReceivedTo: null,
                expirationDateFrom: null,
                expirationDateTo: null,
                lotNo: null,
                DrugCodeList: [],
                pharmacyLocation: '',
                showAllLot: 0,
                PageSize: 10,
                PageNumber: 1
            },
            reasonList: [],
            pharmacyLocations: [],
            pharmacyVModel: null,
            pharmacyToVModel: null,
            pharmacyLocationTo: null,
            ShowLotsOptions: EnumService.DrugOrderItemsShowLots,
            showAllLotModel: { value: 0, name: this.$t('Shared.All') },

            items: [],
            showMessageIsEmpty: false,
            totalRows: 0,
            isReadOnly: false,
            pageOptions: [5, 10, 15],
            visibleEditDialog: false,
            fieldsDate: ['dateReceived','expirationDateItemRemoval'],
            editableItem: {
                drugName: '',
                activeIngred: '',
                expirationDate: '',
                lotNo: '',
                location: '',
                qtyFilled: '',
                qtyReceived: '',
                qtyAvailable: '',
                qtyToMove: null,
                notes: null,
                reasonCode: null
            },
            editableIndex: -1,
            viewText:
                `${this.$t('Shared.SearchResult')} - ` +
                `${this.$t('Shared.Filled')}: 0 - ` +
                `${this.$t('Shared.Received')}: 0 - ` +
                `${this.$t('Shared.Available')}: 0`,

            isItemReloReportVisible: false,

            BaseFields: [
                { key: 'drugname', sortable: true, label: this.$t('Shared.DrugName') },
                { key: 'activeingred', sortable: true, label: this.$t('Shared.activeIngredients') },
                { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage') },
                { key: 'form', sortable: true, label: this.$t('Shared.Form') },
                { key: 'drugCode', sortable: true, label: this.$t('Shared.DrugCode') }
            ],

            SignotecEnabled: false,
            SignotecVisible: false,
            SignotecSignatureFile: null,
            isDateRecFromValid: true,
            isDateRecToValid: true,
            isExpDateFromValid: true,
            isExpDateToValid: true
        };
    },

    computed: {
        fields() {
            return [
                {
                    key: 'dateReceived',
                    sortable: true,
                    label: this.$t('Shared.DateReceived'),
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    }
                },
                {
                    key: 'drugName',
                    sortable: true,
                    label: this.$tc('Shared.DrugName', 1)
                },
                {
                    key: 'activeIngred',
                    sortable: true,
                    label: this.$t('Shared.activeIngredients')
                },
                {
                    key: 'expirationDateItemRemoval',
                    sortable: true,
                    label: this.$t('Shared.ExpirationDate'),
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    }
                },
                {
                    key: 'lotNo',
                    sortable: true,
                    label: this.$t('Shared.LotNo')
                },
                {
                    key: 'locationDescription',
                    sortable: true,
                    label: this.$t('Shared.Location')
                },
                {
                    key: 'qtyFilled',
                    sortable: true,
                    label: this.$t('Shared.Filled')
                },
                {
                    key: 'qtyReceived',
                    sortable: true,
                    label: this.$t('Shared.Received')
                },
                {
                    key: 'qtyAvailable',
                    sortable: true,
                    label: this.$t('Shared.Available')
                }
            ];
        }
    },

    methods: {
        InputReceivedFrom(value) {
            this.parameters.dateReceivedFrom = value;
            this.parameters.PageNumber = 1;
        },

        InputReceivedTo(value) {
            this.parameters.dateReceivedTo = value;
            this.parameters.PageNumber = 1;
        },

        InputExpirationFrom(value) {
            this.parameters.expirationDateFrom = value;
            this.parameters.PageNumber = 1;
        },

        InputExpirationTo(value) {
            this.parameters.expirationDateTo = value;
            this.parameters.PageNumber = 1;
        },

        ChangeLotNo() {
            this.parameters.PageNumber = 1;
        },

        getValuesDrugs(value) {
            this.parameters.DrugCodeList = value;
            this.parameters.PageNumber = 1;
            this.SearchItems();
        },

        goProcess() {
            let data = {
                itemNo: this.editableItem.itemNo,
                qTYToMove: this.editableItem.qtyToMove,
                reasonCode: this.editableItem.reasonCode,
                notes: this.editableItem.notes,
                drugCode: this.editableItem.drugCode,
                location: this.editableItem.location,
                signature: this.SignotecSignatureFile
            };

            ePharmacyItemsReceivedService
                .processRemoval(data)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.SearchItems();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('Drugs') >= 0) {
                this.parameters.drugCode = Utils.isNullOrEmptyString(result.code)
                    ? null
                    : result.code.trim();
                this.DrugName = Utils.isNullOrEmptyString(result.description)
                    ? null
                    : result.description.trim();

                this.parameters.PageNumber = 1;
                this.SearchItems();
            }
        },

        changeDropDownPharmacy(status) {
            this.parameters.PageNumber = 1;
            this.parameters.pharmacyLocation = status ? status.code : '';
            this.SearchItems();
        },

        changeDropDownPharmacyTo(status) {
            this.parameters.PageNumber = 1;
            this.pharmacyLocationTo = status ? status.code : '';
            this.SearchItems();
        },

        ChangeFilter(m) {
            this.modelFilter = m;
        },

        ChangeShowAllModel(item) {
            if (item != null) {
                this.showAllLotModel = item;
                this.parameters.showAllLot = item ? item.value : 0;
            } else {
                this.showAllLotModel = null;
            }
            this.parameters.PageNumber = 1;
            this.SearchItems();
        },

        SearchItems() {
            if (!this.validateForm()) return;

            ePharmacyItemsReceivedService
                .getAvailableForRemoval(this.parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        let data = response.data;
                         data.forEach(function(element) {
                            if (element.expirationDate) element.expirationDateItemRemoval = Utils.formatterDateToString(element.expirationDate);
                            if (element.dateReceived) element.dateReceived = Utils.formatterDateToString(element.dateReceived);
                        });
                        this.items = data;
                        let header = JSON.parse(response.headers['x-pagination']);
                        this.totalRows = header.TotalCount;
                        this.showMessageIsEmpty = this.items.length === 0;
                    }

                    this.SearchItemsTotals();
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        SearchItemsTotals() {
            ePharmacyItemsReceivedService
                .getTotalsAvailableForRemoval(this.parameters)
                .then(response => {
                    if (response.status == '200') {
                        const totals = response.data || { filled: 0, received: 0, available: 0 };

                        this.viewText =
                            `${this.$t('Shared.SearchResult')} - ` +
                            `${this.$t('Shared.Filled')}: ${totals.filled} - ` +
                            `${this.$t('Shared.Received')}: ${totals.received} - ` +
                            `${this.$t('Shared.Available')}: ${totals.available}`;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getPharmacyLocations() {
            this.pharmacyLocations = [];
            ePharmacyItemsLocationService
                .getAllForRemoval()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.pharmacyLocations = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getReason() {
            ReasonService.getReasonInventory()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.reasonList = [
                            ...response.data
                                .filter(item => item.active)
                                .map(item => {
                                    return { key: item.code, value: item.name };
                                })
                        ];
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        initialize() {
            Promise.all([this.getPharmacyLocations(), this.getReason()]);
        },

        pageChanged(page) {
            this.parameters.PageNumber = page;
            this.SearchItems();
        },

        perPageFunction(perPage) {
            this.parameters.PageNumber = 1;
            this.parameters.PageSize = perPage;
            this.SearchItems();
        },

        onRowSelected() {},

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.parameters.PageNumber = 1;
        },

        editHandler(value) {
            this.editableIndex = this.items.findIndex(item => item === value);
            this.editableItem = value;
            this.editableItem.expirationDate = Utils.formatterDateToString(
                this.editableItem.expirationDate
            );
            this.editableItem['qtyToMove'] = value.qtyToMove ? value.qtyToMove : null;
            this.visibleEditDialog = true;
        },

        okHandler() {
            this.visibleEditDialog = false;

            if (this.SignotecEnabled == false || this.SignotecSignatureFile) {
                this.goProcess();
            } else {
                this.SignotecVisible = true;
            }
        },

        closeHandler() {
            this.visibleEditDialog = false;
        },

        ShowReport() {
            this.isItemReloReportVisible = true;
        },

        closeItemReloReportWindow() {
            this.isItemReloReportVisible = false;
        },

        SignotecOnOK() {
            if (!this.SignotecSignatureFile) {
                this.$refs.mdSignotec.confirm();
            }
        },

        SignotecOnCancel() {
            this.SignotecVisible = false;
            this.SignotecSignatureFile = null;
        },

        SignotecOnConfirm() {
            if (this.SignotecSignatureFile) {
                this.SignotecVisible = false;
                this.goProcess();
            } else {
                this.showMessage(this.$tc('Msg.Error'), 'Please sign', 'error');
            }
        },

        SignotecOnSubmitImage(data) {
            this.SignotecSignatureFile = data;
        },

        SignotecOnError(msg) {
            this.showMessage(this.$tc('Msg.Error'), msg, 'error');
        },

        // Método de validación reutilizable
        validateForm() {
            const isValid = this.validateAllRanges();

            // Forzar actualización del componente
            this.$forceUpdate();

            if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), 'error');
                return false;
            }
            return true;
        },

        validateAllRanges() {
            const ranges = [
                {
                    from: this.parameters.dateReceivedFrom,
                    to: this.parameters.dateReceivedTo,
                    index: 1
                },
                {
                    from: this.parameters.expirationDateFrom,
                    to: this.parameters.expirationDateTo,
                    index: 2
                }
            ];

            for (const range of ranges) {
                const isValid = Utils.isDateFromAndDateTo(range.from, range.to);
                let index = range.index;
                if (!isValid) {
                    switch (index) {
                        case 1:
                            this.isDateRecFromValid = this.isDateRecToValid = isValid;
                            break;
                        default:
                            this.isExpDateFromValid = this.isExpDateToValid = isValid;
                            break;
                    }
                    return false; // early exit
                } else {
                    // reset state when validation is ok
                    this.isDateRecFromValid = this.isDateRecToValid = isValid;
                    this.isExpDateFromValid = this.isExpDateToValid = isValid;
                }
            }
            return true;
        }
    },

    mounted() {
        this.initialize();
        this.SearchItems();
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        const userId = LocalStorage.getUserId();
        EmployeeService.GetByUserId(userId)
            .then(response => {
                if (response.data) {
                    let result = response.data;
                    if (
                        result &&
                        result.requestSigRemoveItems &&
                        result.signaturePad == 'Signotec'
                    ) {
                        this.SignotecEnabled = true;
                    }
                }
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    }
};
</script>
